<template>
  <div class="loginBox flexCol">
    <div class="imgBox">
      <img src="../assets/static/loginimg.png"/>
    </div>
    <div class="loginContent flexCol">
      <div class="title">欢迎使用</div>
      <div class="telBox rowAc">
        <input
          v-if="!codeShow"
          type="tel"
          class="telInput"
          placeholder="请输入机构登记的手机号码"
          maxlength="11"
          v-model="phone"
        />
        <div class="checkLogin rowJbAc" v-if="codeShow">
          <input
            type="tel"
            class="telInput"
            placeholder="输入验证码"
            maxlength="6"
            v-model="code"
          />
          <div class="reciveTel">已发送到{{ phone }}</div>
        </div>
      </div>
      <div
        class="checkBox center rowJcAc"
        v-if="/^\d{6}$/.test(this.code)"
        @click.prevent="login"
      >
        <div class="reciveCodeAfter">登录</div>
      </div>
      <!-- 不是机构用户 -->
      <div
        class="checkBox center rowJcAc"
        v-else-if="staffExit == 0"
        @click.prevent="jumpDiscount"
      >
        <div class="reciveCodeAfter">确定</div>
      </div>
      <div class="checkBox center rowJcAc" v-else @click.prevent="getCode">
        <button
          class="reciveCodeBefore"
          :disabled="(!rightPhone || disabledbtn) "
          :class="{ reciveCodeAfter: rightPhone }"
        >
          {{ computeTime > 0 ? `重新获取(${computeTime}s)` : "获取验证码" }}
        </button>
      </div>
    </div>
    <div class="alsrtInfo" :style="{ display: displayStsates }">
      <div class="profPrompt_test center">
        <span>{{ aletMsg }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { postCheckAPI, postBindAPI, postLoginAPI,postCouponReceiveCheckAPI,postAccountRegisterAPI, getStaffCheckExistAPI, postVerifyCodeSendAPI } from "../utils/api/api";

export default {
  name: "Login",
  data() {
    return {
      phone: "", //手机号,
      computeTime: 0,
      code: "", //验证码
      timer: null,
      loginTimer: null, // 登录定时器
      aletMsg: "", // 弹出框中的提示语
      displayStsates: "none",
      openid: "",
      token1: "",
      disabledbtn: false,

      codeShow: false, //手机号码还是验证码显示
      submited: true, //防重复提交，为false时不可再次点击确认按钮
      isReceive: false, // 是否领取优惠券
      staffExit: '-1', // 员工是否存在 -1，还没开始检索，0：不存在,未领取优惠券 1：不存在领取优惠券 2：是机构员工
    };
  },
  computed: {
    rightPhone() {
      //利用正则对手机号匹配
      return /^1[3456789]\d{9}$/.test(this.phone);
    },
  },
  watch: { // 当手机号输入正确时，检查是否为机构用户，机构用户自动登录，否则跳领取优惠券页面
    rightPhone() {
      if(this.rightPhone) {
        this.getStaffCheckExist()
      }else {
        this.staffExit = '-1'
      }
    }
  },
  created() {
    this.openid = this.$common.getCache('openid');
  },
  mounted() {
    // this.checkcode();
  },
  methods: {
    getCode() {
      if(this.disabledbtn || !this.rightPhone) return
      this.disabledbtn = true;
      if(this.staffExit == 1)  { // 非机构用户已经领取了优惠券
        this.getVerifyCode()
        return
      }
      // 校验手机号是否在PC端存在+发送验证码
      let data = { 
        productId: 1,
        clientId: '1004',
        phone: this.phone,
        thirdUniqueId: this.openid
      };
      postCheckAPI(data)
      .then((res) => {
        console.log("验证前", res);
        if (res.resultCode == 200) {
          console.log("成功获取验证码", res);
          this.codeShow = true;
          console.log(this.codeShow);
          if (!this.computeTime) {
            this.computeTime = 60;
            this.timer = setInterval(() => {
              this.computeTime--;

              if (this.computeTime <= 0) {
                clearInterval(this.timer);
                this.disabledbtn = false;
              }
            }, 1000);
          }
        } else {
          this.disabledbtn = false;
          if (res.resultCode === 40402002) {
            this.codeShow = false;
            this.alertDia('手机号码错误！');
          } else { // 已经授权注册但是没有退出登录
            // this.staffExit = 1
            // this.getVerifyCode()
            this.codeShow = false;
            this.alertDia(res.resultStr);
            // this.alertDia(res.resultStr,true,'/receiveCoupon');
          }
        }
      })
      .catch((err) => {
        console.log(err);
        this.codeShow = false;
      });
      
    },
    // 不是机构用户获取验证码
    getVerifyCode() {
      postVerifyCodeSendAPI({
        phone: this.phone
      }).then(res => {
        if(res.resultCode == 200) {
          console.log("成功获取验证码", res);
          this.codeShow = true;
          console.log(this.codeShow);
          if (!this.computeTime) {
            this.computeTime = 60;
            this.timer = setInterval(() => {
              this.computeTime--;

              if (this.computeTime <= 0) {
                clearInterval(this.timer);
                this.disabledbtn = false;
              }
            }, 1000);
          }
        }else {
          this.disabledbtn = false;
          this.codeShow = false;
          this.alertDia(res.resultStr);
        }
      })
    },
    login() {
      if (!this.submited) {
        // console.log('不能点击')
        return;
      }
      
      
      //短信验证
      if (!this.rightPhone) {
        // alert("手机号不正确");
        this.alertDia('验证码发送失败');
      } else if (!/^\d{6}$/.test(this.code)) {
        // alert("验证码必须是6位");
        this.alertDia('验证码错误');
        // 弹出提醒验证码错误
      } else {
        this.submited = false;
        this.loginTimer = setTimeout(() => {
          console.log("可点击");
          this.submited = true;
        }, 10 * 1000);
        if(this.staffExit == 1) { // 非机构用户
          this.noStaffRegister()
        }else {
          this.staffRegister()
        }
        
      }
    },
    // 机构用户
    staffRegister() {
      let data = {
          productId: 1,
          clientId: '1004',
          phone: this.phone,
          verifyCode: this.code,
          thirdUniqueId: this.openid,
        };
        console.log("loginData", data);
        postBindAPI(data).then((res) => {
            
          if (res.resultCode == 200) {
            this.loginAPI()
          } else {
            this.submited = true;
            clearTimeout(this.loginTimer);
            this.alertDia(res.resultStr);
          }
        })
    },
    // 非机构用户注册
    noStaffRegister() {
      postAccountRegisterAPI({
        productId: 1,
        clientId: '1004',
        verifyCode: this.code,
        phone: this.phone,
        thirdUniqueId: this.openid,
        isOnlyRegister: 1
      }).then(res => {
        if(res.resultCode == 200) {
          this.loginAPI()
        } else {
          this.submited = true;
          clearTimeout(this.loginTimer);
          this.alertDia(res.resultStr);
        }
      })
    },
    // 提示弹框
    alertDia(msg,skip=false,url='') {
      this.displayStsates = "block";
      this.aletMsg = msg;
      // 延迟2秒后消失 自己可以更改时间
      window.setTimeout(() => {
        this.displayStsates = "none";
        // 跳转
        if (skip) {
          this.$router.push(url);
        }
      }, 2000);
    },
    // 登录接口
    loginAPI() {
      let data1 = {
        loginMode: 2,
        productId: 1,
        clientId: '1004',
        thirdUniqueId: this.openid,
      };
      postLoginAPI(data1)
        .then((res) => {
          this.submited = true;
          clearTimeout(this.loginTimer);
          if (res.resultCode == 200) {
            console.log("登录成功", res.data);

            this.$common.setCache('tokenCreateTime', new Date().getTime())
            this.$common.setCache('token',res.data.token)
            this.$common.setCache('customerInfo',JSON.stringify(res.data))
            this.alertDia('绑定成功，正在跳转个人信息页面',true,'/mine')
            

          } else {
            this.alertDia(res.resultStr);
          }
      })
    },
    // 检查员工是否存在
    getStaffCheckExist(){
      getStaffCheckExistAPI({
        phone: this.phone
      }).then(res => {
        if(res.resultCode == 200) {
          if(res.data.isExist) { // 员工存在
            this.staffExit = 2
            console.log('----staffExit：', this.staffExit)
          }else {
            postCouponReceiveCheckAPI({ // 检查是否领取优惠券，领取过跳到我的页面，否则跳到领取优惠券页面
              phone: this.phone,
              configId: 1
            }).then(res1 => {
                if(res1.resultCode == 200 && res1.data.isReceive) {
                  this.staffExit = 1;
                }else {
                  this.staffExit = 0
                }
                console.log('----staffExit：', this.staffExit)
            })
          }
          
        }
      })
    },
    // 跳转到领取优惠券页面
    jumpDiscount() {
      this.$common.setCache('loginPhone', this.phone)
      this.alertDia('正在跳转领取优惠券页面填写信息',true,'/receiveCoupon');
    }
  },
};
</script>

<style lang="scss" scoped>
.loginBox {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-sizing: border-box;
  position: relative;
}
.imgBox {
  width: 100%;
  img{
    width: 3.75rem;
  }
}
.loginContent {
  padding: 10px 0.15rem;
}
.title {
  font-size: 20px;
  color: #333843;
  font-weight: 500;
}
.telBox {
  height: 50px;
  background: #f5f6f9;
  border-radius: 12px;
  padding: 0px 10px 0px 20px;
  box-sizing: border-box;
  margin-top: 20px;

  .telInput {
    font-size: 13px;
    border: none;
    color: #333843;
    flex: 1;
    background: #f5f6f9;
    height: 18px;
    line-height: 18px;
  }
}
.checkBox {
  height: 50px;
  background: rgba(105, 133, 255, 0.16);
  border-radius: 12px;
  padding: 16px 0;
  box-sizing: border-box;
  margin-top: 20px;
}
.checkLogin {
  flex: 1;
}
.reciveCodeBefore {
  font-size: 13px;
  font-weight: 500;
  color: rgba(105, 133, 255, 0.4);
  background: none;
  border: none;
}
.reciveCodeAfter {
  font-size: 13px;
  font-weight: 500;
  color: #6985ff;
  background: none;
  border: none;
}
.reciveTel {
  height: 30px;
  font-size: 11px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
  color: #9ea8ba;
  padding: 0px 5px;
  line-height: 30px;
  box-sizing: border-box;
  vertical-align: middle;
}
.alsrtInfo {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 80%;
  left: 4%;
  z-index: 1000;
}
.profPrompt_test {
  display: inline-block;
  height: 44px;
  width: 345px;
  font-size: 12px;
  background: #222222;
  border-radius: 11px;
  line-height: 44px;
  padding: 0px 25px;
  box-sizing: border-box;
  margin: auto;
  color: #ffffff;
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #9ea8ba;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #9ea8ba;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #9ea8ba;
}

input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #9ea8ba;
}
</style>
